<template>
  <div class="text-center">
    <v-menu
      v-if="activeLayers"
      v-model="opacityMenu"
      :close-on-content-click="false"
      :nudge-width="100"
      dark
    >
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
            <v-btn
              outlined
              icon
              small
              v-bind="{ ...attrs, ...tooltipAttrs }"
              :disabled="!activeLayers"
              v-on="{ ...on, ...tooltipOn }"
            >
              <v-icon color="#505050">
                mdi-opacity
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('ServiceCard.transparency') }}</span>
        </v-tooltip>
      </template>

      <v-card
        width="200px"
        light
      >
        <v-card-text class="pa-2 overflow-hidden">
          <span>
            {{ $t('ServiceCard.transparency') }}
          </span>
          <div class="d-flex">
            <v-slider
              v-model="sliderOpacityValue"
              class="ma-0"
              hide-details
              color="#008A2B"
              track-color="#9DDAB4"
              max="100"
              min="0"
              inverse-label
              @input="setLayerOpacity()"
              @mouseup="opacityMenu = false;"
            >
              <template v-slot:label>
                <span class="ml-n2">
                  {{ sliderOpacityValue + "%" }}
                </span>
              </template>
            </v-slider>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>


    <v-btn
      v-else
      :disabled="!activeLayers"
      outlined
      icon
      small
    >
      <v-icon>mdi-opacity</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { svgOpacity } from '@/svg.js';

export default {
  props: {
    serviceCardId: {
      type: String,
      default: ''
    },
    initialOpacity: {
      type: Number,
      default: 60
    }
  },
  data () {
    return {
      opacityMenu: false,
      sliderOpacityValue: this.initialOpacity,
      opacitySvg: svgOpacity
    };
  },
  computed: {
    ...mapState(['map']),
    activeLayers() {
      return this.map.OLmap.getLayers().getArray().some(
        (layer) => layer.values_.service_id === this.serviceCardId
      );
    }
  },
  watch: {
    $route() {},
    initialOpacity: {
      async handler(newValue) {
        if (newValue) {
          this.sliderOpacityValue = this.initialOpacity;
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions([]),
    setLayerOpacity() {
      const layers = this.map.OLmap.getLayers().getArray().slice(1);
      layers.forEach(layer => {
        if (layer.values_.service_id == this.serviceCardId) {
          const newValue = this.sliderOpacityValue / 100;
          layer.setOpacity(newValue);
        }
      });
    }
  }
};
</script>

<style scoped>
.sliderLabel {
  display: flex;
  justify-content: space-between;
}
</style>
